import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import { formatNumber, formatMoney } from 'accounting-js';

import * as DF from 'fixedassets/components/detail/field';

class AssetDetailBuy extends Component {
  render = () => (
    <Form.Section title={this.props.t('assets.section.buy')}>
      <div className="row">
        <DF.Relation label="assets.fields.provider" value={this.props.asset._provider} />
        <DF.Text label="assets.fields.price" value={formatMoney(this.props.asset.price)} />
        <DF.Catalog label="assets.fields.coin" value={this.props.asset._coin} />
        <DF.Text
          label="assets.fields.exchange"
          value={formatNumber(this.props.asset.exchange || 0, { precision: 4 })}
        />
        <DF.Catalog label="assets.fields.buyCondition" value={this.props.asset._buyCondition} />
        <DF.Relation label="assets.fields.costCenter" value={this.props.asset._costCenter} />
        <DF.Text
          label="assets.fields.dollarAssetPrice"
          value={formatMoney(this.props.asset.dollarAssetPrice || 0)}
        />
      </div>
    </Form.Section>
  );
}

export default translate()(AssetDetailBuy);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailBuy.js